module.exports = __webpack_public_path__ + "img/zixun3.24a64dfd.png";